import { useTranslation } from 'react-i18next';

import { useContractPdf } from '~/api/user';
import { PdfPreview, Spinner, Text, Title } from '~/components';
import { statusColorThemes } from '~/styles/themes.css';
import { clsx } from '~/styles/utils';

import { errorStyle, pdfWrapperStyle, wrapperStyle } from './FrameworkAgreement.css';

type Props = {
  hasSigned: boolean;
  isAddendum: boolean;
};

export const FrameworkAgreement = ({ hasSigned, isAddendum }: Props) => {
  const { data: contractPdf, isError } = useContractPdf(isAddendum, !hasSigned);

  const { t } = useTranslation(['common', 'dashboard']);

  return (
    <div className={wrapperStyle}>
      <Title as="h3" styleAs="h5">
        {t('dashboard:frameworkAgreement.title')}
      </Title>

      <Text>{t('dashboard:frameworkAgreement.subtitle')}</Text>

      {hasSigned ? (
        <Text>{t('dashboard:frameworkAgreement.alreadySigned')}</Text>
      ) : isError ? (
        <Text className={clsx(errorStyle, statusColorThemes.danger)}>{t('common:error')}</Text>
      ) : (
        <div className={pdfWrapperStyle}>
          {contractPdf ? (
            <PdfPreview src={`data:application/pdf;base64,${contractPdf}`} title={t('dashboard:frameworkAgreement.title')} />
          ) : (
            <Spinner size={40} />
          )}
        </div>
      )}
    </div>
  );
};
